import { WebViewComponent } from '@/components/WebView'

export default function () {
  return <WebViewComponent url={'https://store.pokerpower.com'} />
}
